import react from "react";
import axios from '../../axios/axiosconf'
import { debeFiltrarPorProfesional } from '../../../utils/userAccessHelpers';
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link, useLocation } from "react-router-dom";
import Loading from "../general/Loading";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import ModalResumenRemision from "./ModalResumenRemision";
import { formatFecha } from "../../../resources/Helper";
import html2pdf from "html2pdf-fix-jspdf";
import { Modal, Button } from "react-bootstrap";

function ModalRecomendaciones(props) {

    const queryParams = useLocation().search;
    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(true);
    const [client, setClient] = useState([]);

    const paciente_id = new URLSearchParams(queryParams).get('id');

    const [pacienteId, setPacienteId] = useState(new URLSearchParams(queryParams).get('id'));


    const [contenido, setContenido] = useState('');
    const [fechaHora, setFechaHora] = useState('');
    const [horaInicial, setHoraInicial] = useState('');

    const [nombreProfesional, setNombreProfesional] = useState('');
    const [profesionalTratante, setProfesionalTratante] = useState(''); // 🆕 Profesional tratante (usuario logueado)
    const [registroMedico, setRegistroMedico] = useState('');
    const [codigoHabilitacion, setCodigoHabilitacion] = useState('');
    const [firmaimg, setFirmaimg] = useState('');
    const [textoPieFirma, setTextoPieFirma] = useState('');

    const [historial, setHistorial] = useState([]);
    const [plantillas, setPlantillas] = useState([]);

    const [errorlist, setErrorlist] = useState({});

    const [tituloResumen, setTituloResumen] = useState();
    const [contenidoResumenIndividual, setContenidoResumenIndividual] = useState();

    const [consolidado, setConsolidado] = useState('');

    // 🆕 ESTADO PARA ENCABEZADO PERSONALIZADO
    const [encabezadoPersonalizado, setEncabezadoPersonalizado] = useState(null);

    // 🆕 ESTADOS PARA MODALES REACT
    const [showModalConsolidado, setShowModalConsolidado] = useState(false);
    const [showModalResumen, setShowModalResumen] = useState(false);
    const [showModalConfirmacion, setShowModalConfirmacion] = useState(false);
    const [pdfNativoConfigIndividual, setPdfNativoConfigIndividual] = useState(null);
    const [pdfNativoConfigConsolidado, setPdfNativoConfigConsolidado] = useState(null);

    let history = useHistory();
    let userdata = [];
    const logoImg = '/smile/dist/img/logo-2.png';
    const [deshabilitarBotonGuardar, setDeshabilitarBotonGuardar] = useState(false);

    useEffect(() => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
            }
        }

        axios.get('/get-client', config)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                }
            })
            .catch(error => {
                console.log(error);
            });

        axios.get('/perfil', config)
            .then(response => {
                if (response.status === 200) {

                    setNombreProfesional(response.data.name + ' ' + response.data.lastname);
                    setProfesionalTratante(response.data.name + ' ' + response.data.lastname); // 🆕 Profesional tratante
                    setRegistroMedico(response.data.registro_medico ?? '');
                    setCodigoHabilitacion(response.data.codigo_habilitacion ?? '');
                    setFirmaimg(response.data.firma_blob);
                    setTextoPieFirma(response.data.texto_pie_firma || '');
                }
            })
            .catch(error => {
                console.log(error);
            });

        axios.get('/plantillas-recomendaciones', {
            ...config,
            headers: {
                ...config.headers,
                'X-Suppress-403-Modal': '1',
            },
        })
            .then(response => {
                setPlantillas(Array.isArray(response.data) ? response.data : []);
            })
            .catch(error => {
                console.log(error);
                setPlantillas([]);
            })

        // 🆕 Cargar encabezado personalizado del usuario (Igual que en ModalFormulas)
        axios.get('/encabezado-personalizado?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200 && response.data && response.data.estado === 1) {
                    setEncabezadoPersonalizado(response.data);
                    console.log('Encabezado personalizado cargado:', response.data);
                }
            })
            .catch(error => {
                console.log('No hay encabezado personalizado habilitado:', error);
                setEncabezadoPersonalizado(null);
            });

    }, []);

    const generarEncabezadoHTML = () => {
        if (!encabezadoPersonalizado) {
            return '';
        }

        // Función auxiliar para limpiar HTML y evitar saltos de línea innecesarios
        const limpiarHTML = (html) => {
            if (!html) return '';
            // Reemplazar <p> tags con divs para un control más preciso
            return html
                .replace(/<p>/gi, '<div style="margin: 0; padding: 0; line-height: 1.1;">')
                .replace(/<\/p>/gi, '</div>')
                .replace(/<br\s*\/?>/gi, '<br style="line-height: 1.1;" />');
        };

        // USAR TABLA EN LUGAR DE FLEXBOX PARA MEJOR COMPATIBILIDAD CON PDF
        return `
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 10px; background-color: #ffffff;">
                <tr>
                    <!-- Columna Izquierda (30%) -->
                    <td style="width: 30%; padding: 2px; font-size: 10px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.izquierda)}
                    </td>
                    
                    <!-- Columna Centro (40%) -->
                    <td style="width: 40%; padding: 2px; text-align: center; font-size: 11px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.centro)}
                    </td>
                    
                    <!-- Columna Derecha (30%) -->
                    <td style="width: 30%; padding: 2px; text-align: right; font-size: 10px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.derecha)}
                    </td>
                </tr>
            </table>
        `;
    };

    const obtenerDatosPacientePdf = () => {
        const p = props.paciente;
        if (!p) {
            return { nombreCompleto: 'Paciente no identificado', documentoCompleto: '—' };
        }
        const nombreCompleto = `${p.primerNombre || ''} ${p.segundoNombre || ''} ${p.primerApellido || ''} ${p.segundoApellido || ''}`.trim() || 'Paciente no identificado';
        const documentoCompleto = p.tipoDocumento && p.numeroDocumento
            ? `${p.tipoDocumento} - ${p.numeroDocumento}`
            : (p.numeroDocumento || '—');
        return { nombreCompleto, documentoCompleto };
    };

    /** Firma sin banda gris (patrón Otros Documentos / Fórmulas). */
    const htmlFirmaProfesionalDesdeItem = (item) => {
        const firmaSrc = item.firma_final || item.firma;
        if (!item.profesional || !firmaSrc) return '';
        const pieFirmaHtml = item.texto_pie_firma_usuario
            ? `<div style="font-size: 13px; color: #6c757d; line-height: 1.45; white-space: pre-line;">${item.texto_pie_firma_usuario}</div>`
            : `<div style="font-size: 13px; color: #6c757d; line-height: 1.45;">
                    <strong>${item.profesional}</strong><br/>
                    RM: ${item.registro_medico || 'N/A'} | Habilitación: ${item.codigo_habilitacion || 'N/A'}
                  </div>`;
        return `
                <div style="height: 1px; background-color: #e9ecef; margin: 24px 0; width: 100%;" role="presentation" aria-hidden="true"></div>
                <div style="margin-top: 0; margin-bottom: 12px; padding-left: 12px; page-break-inside: avoid;">
                    <div style="font-weight: 700; margin-bottom: 8px; text-transform: uppercase; font-size: 13px; color: #212529;">
                        Firma del profesional
                    </div>
                    <div style="display: flex; flex-wrap: wrap; align-items: flex-start; gap: 14px;">
                        <div style="flex: 1; min-width: 160px;">${pieFirmaHtml}</div>
                        <div style="flex-shrink: 0;">
                            <img src="${firmaSrc}" alt="" style="max-width: 180px; max-height: 90px; display: block;" />
                        </div>
                    </div>
                </div>`;
    };

    const encabezadoPdfNativoDesdeEstado = () => (
        encabezadoPersonalizado && Number(encabezadoPersonalizado.estado) === 1
            ? {
                izquierda: encabezadoPersonalizado.izquierda || '',
                centro: encabezadoPersonalizado.centro || '',
                derecha: encabezadoPersonalizado.derecha || ''
            }
            : null
    );

    const rellenarSeccionesPdfRecomendacionItem = (secciones, item, { incluirPaciente = true } = {}) => {
        const { nombreCompleto, documentoCompleto } = obtenerDatosPacientePdf();

        const profTrat = item.profesional_tratante_completo &&
            item.profesional_tratante_completo !== 'No registrado'
            ? item.profesional_tratante_completo
            : 'No registrado';

        const filasMeta = [];
        if (incluirPaciente) {
            filasMeta.push({ etiqueta: 'PACIENTE', valor: nombreCompleto });
            filasMeta.push({ etiqueta: 'DOCUMENTO', valor: documentoCompleto });
        }
        filasMeta.push({ etiqueta: 'FECHA Y HORA', valor: String(item.fecha || '') });
        filasMeta.push({ etiqueta: 'PROFESIONAL TRATANTE', valor: profTrat });

        const gris = [248, 249, 250];
        secciones.push({
            tipo: 'tabla-datos',
            datos: { filas: filasMeta },
            estilos: {
                bodyStyles: { fillColor: gris },
                alternateRowStyles: { fillColor: gris },
                columnStyles: {
                    0: { cellWidth: 52, fontStyle: 'bold', fillColor: gris },
                    1: { cellWidth: 'auto', fillColor: gris },
                },
            },
        });

        secciones.push({
            tipo: 'subtitulo',
            contenido: 'RECOMENDACIONES MÉDICAS',
            estilos: {
                alineacion: 'center',
                fontSize: 12,
                margenSuperiorMm: 4,
                espacioDespuesMm: 6,
            },
        });

        const cuerpoHtml = (item.contenido && String(item.contenido).trim())
            ? item.contenido
            : '<p style="margin:0; color:#6c757d; font-style:italic;">Sin contenido especificado</p>';

        secciones.push({
            tipo: 'texto',
            contenido: cuerpoHtml,
            estilos: { margenSuperiorMm: 1 },
        });

        const tieneProf = item.profesional_tratante_completo &&
            item.profesional_tratante_completo !== 'No registrado';
        const firmaSrc = item.firma_final || item.firma;
        if (tieneProf && item.profesional && firmaSrc) {
            const metaPdf = item.texto_pie_firma_usuario
                ? { tipo: 'profesional', textoPieFirma: item.texto_pie_firma_usuario }
                : {
                    tipo: 'profesional',
                    nombre: item.profesional || '',
                    registroMedico: item.registro_medico || 'N/A',
                    codigoHabilitacion: item.codigo_habilitacion || 'N/A'
                  };
            secciones.push({
                tipo: 'firma',
                imagenBase64: firmaSrc,
                metadata: metaPdf,
                estilos: {
                    estiloEvolucion: true,
                    separadorPrevia: true,
                    margenSuperiorMm: 4,
                },
            });
        }
    };

    const construirConfigPdfRecomendacionNativo = (recomendacion) => {
        const { nombreCompleto, documentoCompleto } = obtenerDatosPacientePdf();
        const slug = props.docPaciente || props.paciente?.numeroDocumento || 'paciente';
        const config = {
            filename: `recomendacion-${slug}.pdf`,
            paciente: { nombreCompleto, documentoCompleto },
            encabezadoPersonalizado: encabezadoPdfNativoDesdeEstado(),
            omitTablaPacienteInicial: true,
            secciones: []
        };
        rellenarSeccionesPdfRecomendacionItem(config.secciones, recomendacion, { incluirPaciente: true });
        return config;
    };

    const construirConfigPdfRecomendacionesConsolidadoNativo = () => {
        if (!historial || historial.length === 0) return null;
        const { nombreCompleto, documentoCompleto } = obtenerDatosPacientePdf();
        const slug = props.docPaciente || props.paciente?.numeroDocumento || 'paciente';
        const config = {
            filename: `recomendaciones-consolidado-${slug}.pdf`,
            paciente: { nombreCompleto, documentoCompleto },
            encabezadoPersonalizado: encabezadoPdfNativoDesdeEstado(),
            omitTablaPacienteInicial: true,
            secciones: []
        };
        config.secciones.push({
            tipo: 'subtitulo',
            contenido: 'HISTORIAL DE RECOMENDACIONES',
            estilos: {
                alineacion: 'center',
                fontSize: 13,
                margenSuperiorMm: 0,
                espacioDespuesMm: 8,
            },
        });
        historial.forEach((it, index) => {
            if (index > 0) config.secciones.push({ tipo: 'salto-pagina' });
            rellenarSeccionesPdfRecomendacionItem(config.secciones, it, { incluirPaciente: true });
        });
        return config;
    };

    const construirHtmlCuerpoRecomendacionItem = (item) => {
        const { nombreCompleto, documentoCompleto } = obtenerDatosPacientePdf();

        const profTrat = item.profesional_tratante_completo &&
            item.profesional_tratante_completo !== 'No registrado'
            ? item.profesional_tratante_completo
            : 'No registrado';

        const celdaEtiqueta = 'background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 28%; border: 1px solid #dee2e6;';
        const celdaValor = 'background-color: #f8f9fa; padding: 8px 12px; border: 1px solid #dee2e6;';

        const tablaUnificada = `
            <div style="margin-bottom: 14px;">
                <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                    <tbody>
                        <tr>
                            <td style="${celdaEtiqueta}">PACIENTE</td>
                            <td style="${celdaValor}">${nombreCompleto}</td>
                        </tr>
                        <tr>
                            <td style="${celdaEtiqueta}">DOCUMENTO</td>
                            <td style="${celdaValor}">${documentoCompleto}</td>
                        </tr>
                        <tr>
                            <td style="${celdaEtiqueta}">FECHA Y HORA</td>
                            <td style="${celdaValor}">${item.fecha || ''}</td>
                        </tr>
                        <tr>
                            <td style="${celdaEtiqueta}">PROFESIONAL TRATANTE</td>
                            <td style="${celdaValor} font-weight: bold; color: #325e68;">${profTrat}</td>
                        </tr>
                    </tbody>
                </table>
            </div>`;

        const tituloCentrado = `
            <div style="margin: 8px 0 14px; text-align: center; font-weight: bold; font-size: 15px; color: #212529; letter-spacing: 0.02em;">
                RECOMENDACIONES MÉDICAS
            </div>`;

        const cuerpoHtml = (item.contenido && String(item.contenido).trim())
            ? item.contenido
            : '<p style="margin:0; color:#6c757d; font-style:italic;">Sin contenido especificado</p>';

        const bloqueContenido = `
            <div style="margin-bottom: 12px;">
                <div style="font-size: 13px; line-height: 1.55;">
                    <style type="text/css">
                        .recomendacion-preview-rich p { margin: 0 0 0.9em 0; }
                        .recomendacion-preview-rich p:last-child { margin-bottom: 0; }
                        .recomendacion-preview-rich ul,
                        .recomendacion-preview-rich ol { margin: 0 0 0.85em 0; padding-left: 1.35em; }
                        .recomendacion-preview-rich,
                        .recomendacion-preview-rich * {
                            white-space: normal;
                            overflow-wrap: anywhere;
                            word-break: break-word;
                        }
                    </style>
                    <div class="recomendacion-preview-rich">${cuerpoHtml}</div>
                </div>
            </div>`;

        const bloqueFirma = (item.profesional_tratante_completo &&
            item.profesional_tratante_completo !== 'No registrado')
            ? htmlFirmaProfesionalDesdeItem({
                ...item,
                firma_final: item.firma_final || item.firma,
                profesional: item.profesional || item.profesional_tratante_completo
            })
            : '';

        return tablaUnificada + tituloCentrado + bloqueContenido + bloqueFirma;
    };

    const construirHtmlVistaRecomendacionNativa = (item) => {
        const encabezadoPrev = encabezadoPersonalizado && Number(encabezadoPersonalizado.estado) === 1
            ? generarEncabezadoHTML()
            : '';
        return encabezadoPrev +
            '<div class="vista-recomendacion-pdf-paridad" style="font-family: sans-serif; color: #212529;">' +
            construirHtmlCuerpoRecomendacionItem(item) +
            '</div>';
    };

    const construirHtmlConsolidadoRecomendaciones = (items) => {
        if (!Array.isArray(items) || items.length === 0) return '';
        const encabezadoPrev = encabezadoPersonalizado && Number(encabezadoPersonalizado.estado) === 1
            ? generarEncabezadoHTML()
            : '';
        const titulo = `
            <div style="margin: 0 0 16px; text-align: center; font-weight: bold; font-size: 15px; color: #212529;">
                HISTORIAL DE RECOMENDACIONES
            </div>`;
        let bloques = '';
        items.forEach((item, i) => {
            if (i > 0) {
                bloques += '<div style="height: 1px; background-color: #e9ecef; margin: 24px 0; width: 100%;"></div>';
            }
            bloques += `<div style="page-break-inside: avoid;">${construirHtmlCuerpoRecomendacionItem(item)}</div>`;
        });
        return encabezadoPrev +
            '<div class="consolidado-recomendaciones-pdf-paridad" style="font-family: sans-serif; color: #212529;">' +
            titulo +
            bloques +
            '</div>';
    };

    const cargaritems = () => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const esProfesionalIndependiente = debeFiltrarPorProfesional(userdata);

        const config2 = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                id: paciente_id
            }
        }

        if (esProfesionalIndependiente) {
            config2.params.validar_asignacion = true;
        }

        axios.get('/recomendaciones', config2)
            .then(response => {
                console.log('Respuesta recomendaciones:', response.data);
                const lista = Array.isArray(response.data) ? response.data : [];
                setHistorial(lista);
                try {
                    setConsolidado(construirHtmlConsolidadoRecomendaciones(lista));
                } catch (e) {
                    console.error('Error generando consolidado recomendaciones:', e);
                    setConsolidado('');
                }
            })
            .catch(error => {
                console.log('Error cargando recomendaciones:', error);
                setHistorial([]);
                setConsolidado('');
            })
    }


    const contenidoHandler = (event, editor) => {
        setContenido(editor.getData());
    }

    const establecerFechaHoraActual = () => {
        const ahora = new Date();
        const fechaFormateada = ahora.toISOString().slice(0, 16);
        setFechaHora(fechaFormateada);
        setHoraInicial(fechaFormateada);
    }




    const contenidoRecomendacionNoVacio = () => {
        if (!contenido || !String(contenido).trim()) return false;
        const plain = String(contenido).replace(/<[^>]+>/g, ' ').replace(/&nbsp;/gi, ' ').trim();
        return plain.length > 0;
    };

    const handleCerrarModalConfirmacion = () => {
        setShowModalConfirmacion(false);
        setDeshabilitarBotonGuardar(false);
        // No guardarCambios(msg): evita toast duplicado; el modal ya informa el éxito y cargaritems() ya corrió al guardar.
    };

    const handleSubmit = (e) => {

        e.preventDefault();

        if (!fechaHora || !String(fechaHora).trim()) {
            alert('La fecha y hora son obligatorias.');
            return;
        }
        if (!contenidoRecomendacionNoVacio()) {
            alert('El contenido de la recomendación es obligatorio.');
            return;
        }

        setLoading(true);

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const esProfesionalIndependiente = debeFiltrarPorProfesional(userdata);

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            paciente_id: pacienteId,
            client_id: client.client_id,
            users_id: userdata.user_id, // 🆕 Agregar users_id para profesional tratante
            profesional: nombreProfesional,
            registro_medico: registroMedico,
            codigo_habilitacion: codigoHabilitacion,
            contenido: contenido,
            hora_inicial: fechaHora || horaInicial
        }

        // 🆕 PROFESIONAL INDEPENDIENTE - Agregar parámetro de validación si es necesario
        if (esProfesionalIndependiente) {
            config.validar_asignacion = true;
        }

        console.log('Enviando datos de recomendación:', config);

        axios.post('/recomendacion', config)
            .then(response => {
                console.log('Recomendación guardada exitosamente:', response.data);
                setLoading(false);
                setContenido('');
                setFechaHora('');
                setHoraInicial('');
                if (document.getElementById('plantillasRecomendaciones')) {
                    document.getElementById('plantillasRecomendaciones').value = "";
                }
                setDeshabilitarBotonGuardar(true);
                cargaritems();
                setErrorlist({});
                setTimeout(() => setShowModalConfirmacion(true), 500);
            })
            .catch(error => {
                setLoading(false);
                console.log('Error guardando recomendación:', error);
                if (error.response && error.response.data && error.response.data.errors) {
                    setErrorlist(error.response.data.errors);
                } else {
                    setErrorlist({});
                    const d = error.response && error.response.data ? error.response.data : null;
                    const msg = (d && (d.message || d.error)) || error.message || 'No se pudo guardar la recomendación.';
                    alert(msg);
                }
            })
    }

    const verRecomendacion = (recomendacion) => {
        setTituloResumen('Recomendaciones Médicas - Vista Previa');
        setPdfNativoConfigIndividual(construirConfigPdfRecomendacionNativo(recomendacion));
        setContenidoResumenIndividual(construirHtmlVistaRecomendacionNativa(recomendacion));
        setShowModalResumen(true);
    }

    const nuevaRecomendacion = () => {
        setDeshabilitarBotonGuardar(false);
        setFechaHora('');
        setContenido('');

        if (document.getElementById('plantillasRecomendaciones')) {
            document.getElementById('plantillasRecomendaciones').value = "";
        }
    }


    useEffect(() => {
        if (!props.cargarHistorial) return;
        cargaritems();

        return () => {
            setPdfNativoConfigIndividual(null);
            setPdfNativoConfigConsolidado(null);
        };
    }, [props.cargarHistorial]);


    const descargarPdf = () => {

        var opt = {
            margin: 12,
            filename: `recomendaciones.pdf`,
            image: { type: 'jpeg', quality: 0.97 },
            html2canvas: { scale: 2, useCORS: true, allowTaint: true },
            jsPDF: { unit: 'mm', format: 'letter', orientation: 'portrait' }
        };

        let anamnesis = props.anamnesis();
        let recomendacionesCompleta = "<img src='" + logoImg + "' class='app-logo-pdf' /><h1 class='ttl-pdf'>RECOMENDACIONES</h1>" + anamnesis + "<div class='salto-pagina-pdf'></div>" + consolidado;

        html2pdf(recomendacionesCompleta, opt);
    }



    if (loggedIn) {
        return (

            <>
                <section className="content">
                    <div className="container-fluid">

                        <div className="row">
                            <div className="col-md-9">

                                <form id="role-form" onSubmit={handleSubmit} autoComplete="off">

                                    <div id="historiageneral">
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-md-5">
                                                        <div className="form-group">
                                                            <label><i className="fas fa-user-md"></i> Profesional Tratante</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={profesionalTratante}
                                                                readOnly
                                                                style={{ backgroundColor: '#f8f9fa', fontWeight: 'bold' }}
                                                            />
                                                            <small className="text-muted">Usuario que realiza la recomendación</small>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-7">
                                                        <div className="form-group">
                                                            <label>Fecha y Hora <span className="text-danger">*</span></label>
                                                            <div className="input-group">
                                                                <input type="datetime-local" className="form-control" required value={fechaHora || ''} onChange={(e) => {
                                                                    setFechaHora(e.target.value);
                                                                    setHoraInicial(e.target.value);
                                                                }} />
                                                                <div className="input-group-append">
                                                                    <button type="button" className="btn btn-sm btn-dark" onClick={establecerFechaHoraActual}>
                                                                        <i className="fas fa-clock"></i> Fecha y Hora Actual
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="form-group">
                                                    <label>Seleccione la recomendación o digite su contenido <span className="text-danger">*</span></label>
                                                    <select
                                                        name="plantillasRecomendaciones"
                                                        className="form-control"
                                                        id="plantillasRecomendaciones"
                                                        onChange={(e) => setContenido(e.target.value)}
                                                    >
                                                        <option></option>
                                                        {(Array.isArray(plantillas) ? plantillas : []).map((plantilla, index) =>
                                                            <option key={index} value={plantilla.contenido}>{plantilla.titulo}</option>
                                                        )}
                                                    </select>
                                                </div>

                                                <div className="form-group" style={{ marginBottom: 0 }}>
                                                    <label>Contenido</label>
                                                    <CKEditor editor={ClassicEditor} onChange={contenidoHandler} data={contenido} />
                                                    {errorlist.contenido && (
                                                        <div className="invalid-feedback visible">
                                                            {errorlist.contenido}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card">
                                        <div id="profesional-atiende">
                                            <div className="card-body" style={{ padding: '0.7rem' }}>
                                                <div className="row">
                                                    {firmaimg && (
                                                        <div className="col-md-4">
                                                            <div className="form-group" style={{ marginBottom: '0.4rem' }}>
                                                                <label>Firma del profesional</label>
                                                                <br />
                                                                <img src={firmaimg} className="firma-profesional-hc" alt="" />
                                                            </div>
                                                        </div>
                                                    )}
                                                    <div className={firmaimg ? 'col-md-8' : 'col-md-12'}>
                                                        <div className="form-group" style={{ marginBottom: '0.4rem' }}>
                                                            <label>Pie de firma</label>
                                                            <br />
                                                            {textoPieFirma ? (
                                                                <div style={{ whiteSpace: 'pre-line', fontSize: '0.75rem', color: '#495057', lineHeight: '1.6' }}>
                                                                    {textoPieFirma}
                                                                </div>
                                                            ) : (
                                                                <div style={{ fontSize: '0.75rem', color: '#6c757d' }}>
                                                                    {nombreProfesional}
                                                                    <br />
                                                                    <small>
                                                                        RM: {registroMedico || 'N/A'} | Hab: {codigoHabilitacion || 'N/A'}
                                                                    </small>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <button type="submit" className="btn btn-secondary" disabled={deshabilitarBotonGuardar}>
                                                Guardar&nbsp;
                                                {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null}
                                            </button>
                                            &nbsp;
                                            <button type="button" className="btn btn-outline-secondary" onClick={(e) => { e.preventDefault(); props.cerrarModal(); }}>Cerrar</button>
                                        </div>
                                    </div>

                                </form>

                            </div>
                            <div className="col-md-3">
                                <div className="timeline-evolucion">

                                    <b className="titulo-historial">Historial de Recomendaciones</b>

                                    {
                                        (Array.isArray(historial) ? historial : []).map((item) =>

                                            <div className="timeline-item-container" key={item.id} onClick={() => verRecomendacion(item)} style={{ cursor: 'pointer' }}>
                                                <div className="timeline-punto-container"><div className="timeline-punto"></div></div>
                                                <div className="timeline-meta">{formatFecha(new Date(item.fecha))}</div>
                                            </div>
                                        )
                                    }

                                </div>

                                <button type="button" className="btn btn-sm btn-dark btn-resumen-historico" onClick={() => {
                                    if (!historial || historial.length === 0) {
                                        alert('No hay recomendaciones en el historial.');
                                        return;
                                    }
                                    setPdfNativoConfigConsolidado(construirConfigPdfRecomendacionesConsolidadoNativo());
                                    setShowModalConsolidado(true);
                                }}>Ver todo</button>

                            </div>
                        </div>
                    </div>
                </section>

                {showModalResumen && (
                    <ModalResumenRemision
                        idModal="modalResumenRecomendaciones"
                        titulo={tituloResumen}
                        contenido={contenidoResumenIndividual}
                        encabezadoPersonalizado={encabezadoPersonalizado}
                        tipoArchivo="recomendacion"
                        docPaciente={props.docPaciente}
                        cliente={client}
                        pdfNativoConfig={pdfNativoConfigIndividual}
                        incluirTituloPdf={false}
                        pdfAltoContraste={true}
                        onClose={() => {
                            setShowModalResumen(false);
                            setPdfNativoConfigIndividual(null);
                        }}
                    />
                )}

                {showModalConsolidado && (
                    <ModalResumenRemision
                        idModal="modalConsolidadoRecomendaciones"
                        titulo="Resumen Recomendaciones"
                        contenido={consolidado}
                        encabezadoPersonalizado={encabezadoPersonalizado}
                        tipoArchivo="historico-recomendaciones"
                        docPaciente={props.docPaciente}
                        cliente={client}
                        pdfNativoConfig={pdfNativoConfigConsolidado}
                        incluirTituloPdf={false}
                        pdfAltoContraste={true}
                        onClose={() => {
                            setShowModalConsolidado(false);
                            setPdfNativoConfigConsolidado(null);
                        }}
                    />
                )}

                <Modal show={showModalConfirmacion} onHide={handleCerrarModalConfirmacion} centered>
                    <Modal.Header closeButton>
                        <Modal.Title className="text-secondary" style={{ fontSize: '1.1rem' }}>
                            <i className="fas fa-file-medical mr-1"></i> Recomendación Guardada
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p className="mb-0" style={{ fontSize: '16px' }}>
                            La Recomendación ha sido Guardada Exitosamente. Puede abrirla desde el Historial para Vista Previa o PDF.
                        </p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" size="sm" onClick={handleCerrarModalConfirmacion}>
                            <i className="fas fa-times mr-1"></i> Cerrar
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>


        );
    }

    return (
        <Loading />
    );
}
export default ModalRecomendaciones;